module.exports = __webpack_public_path__ + "static/media/paraya.4dfd220e.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/fish/paraya.png
// module id = 327
// module chunks = 0